import { useUser } from "@/auth/useUser";
import { useMedspaIntercomInfoQuery } from "@/graphql/queries/medspaIntercomInfo.graphql.types";

export const useIntercomAdditionalAttributes = () => {
  const { userMedspa, medspa } = useUser();
  const { data: medspaIntercomInfo } = useMedspaIntercomInfoQuery({
    variables: {
      medspaId: medspa,
    },
    skip: !medspa,
  });

  if (!medspaIntercomInfo) return null;

  const medspaData = medspaIntercomInfo.medspaByPk;
  if (!medspaData) return null;

  // These keys need to be included as custom attributes in Intercom.
  return {
    user_medspa_admin_link: `${process.env.NEXT_PUBLIC_DJANGO_URI}/admin/medspas/usermedspa/${userMedspa.id}/change`,
    company: {
      company_id: medspaData.id,
      name: medspaData.name,
      medspa_id: medspaData.id,
      medspa_admin_link: `${process.env.NEXT_PUBLIC_DJANGO_URI}/admin/medspas/medspa/${medspaData.id}/change`,
      medspa_state: medspaData.address?.state || null,
      stripe_account_number: medspaData.stripeAccountId,
      stripe_account_link: medspaData.stripeAccountId
        ? `https://dashboard.stripe.com/connect/accounts/${medspaData.stripeAccountId}/activity`
        : null,
    },
  };
};
